import { BillingApi, Configuration } from '@/api';
import { Invoice } from '@/models/Invoice';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export const getInvoiceQueryKey = (invoiceId?: string) => ['invoice', invoiceId] as const;

const useGetInvoiceQuery = (invoiceId?: string) => {
  const queryClient = useQueryClient();
  const auth = useAuth();
  const billingApi = new BillingApi(new Configuration(auth));

  const queryKey = getInvoiceQueryKey(invoiceId);

  const {
    data: invoice,
    isLoading,
    isFetching,
    error,
  } = useQuery<Invoice | undefined>({
    queryKey,
    queryFn: () => {
      if (!invoiceId) throw new Error('Missing invoiceId');
      return billingApi.getInvoice(invoiceId);
    },
    enabled: Boolean(invoiceId),
  });

  const invalidateQuery = async () => {
    return queryClient.invalidateQueries({ queryKey });
  };

  return {
    invoice,
    isLoading,
    isFetching,
    error,
    invalidateQuery,
  };
};

export default useGetInvoiceQuery;
